// Module
var code = "<div id=\"page-marker\" class=\"sp-page-marker\" ng-class=\" {\n        hidden: $ctrl.isPageMarkerHidden\n    } \"> <sp-svg hash=\"iconPageMark\"> </sp-svg> </div> ";
// Exports
export default code;